import { MockService } from '@http/clients/reporting-app/mock.service';
import { GridDisplayScheme, OverviewLayout } from '@pages/reports/types/report-layout-type.enum';
import { IReportConfiguration } from '../../types/report-config.interface';
import { ReportType } from '../../types/report-type.enum';

export const ServiceModuleLabor: IReportConfiguration<MockService> = {
    base: {
        type: ReportType.ServiceModuleLabor,
        serviceType: MockService
    },
    overviewTab: {
        widgets: [],
        layout: OverviewLayout.TwoPlusOne
    },
    gridTab: {
        widgets: [],
        layout: GridDisplayScheme.Standard
    },
    filters: {
        main: [],
        additional: []
    }
};
